module.exports = __webpack_public_path__ + "static/media/twitter.b1ac635b.svg";